import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { Reveal, Overline } from "./Reveal";
import { FAQS } from "../config/site";

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1fr_1.6fr] gap-14">
        <Reveal>
          <Overline>Good to Know</Overline>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl font-bold text-brand-ink tracking-tight leading-tight">
            Questions,
            <span className="italic text-brand-green"> answered.</span>
          </h2>
          <p className="mt-5 text-brand-mute leading-relaxed max-w-sm">
            Everything guests usually ask before their first visit. Still
            curious? WhatsApp us — we reply fast.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-b border-brand-green/15"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="text-left font-serif text-lg sm:text-xl font-semibold text-brand-ink hover:text-brand-green hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${i}`}
                  className="text-brand-mute leading-relaxed pb-6"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
